import script from "./MainOsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MainOsPage.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/main.css?vue&type=style&index=0&id=32937d66&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32937d66"]])

export default __exports__